import { Box, Tooltip } from '@mui/material';
import { Info } from 'lucide-react';
import {
    LabelText,
    LabelValueBox,
    StyledIdField,
    ValueText,
} from '~/components/Fields/TooltipLabeledValue';
import { StructureSet } from '~/domain/patient/structureset';

export function StructureSetInfo({
    structureSet,
}: {
    structureSet: StructureSet;
}) {
    return (
        <Box
            display="flex"
            gap={0.5}
            alignItems="center"
            sx={(theme) => ({
                color: theme.palette.primary.main,
            })}
        >
            <Tooltip
                title={
                    <Box whiteSpace="nowrap">
                        <LabelValueBox>
                            <LabelText>Structures</LabelText>
                            <ValueText>
                                {structureSet.roiArray.length}
                            </ValueText>
                        </LabelValueBox>
                        <LabelValueBox>
                            <LabelText>Label</LabelText>
                            <ValueText>
                                {structureSet.structureSetLabel}
                            </ValueText>
                        </LabelValueBox>
                        {structureSet.generationModel && (
                            <LabelValueBox>
                                <LabelText>Model:</LabelText>
                                <ValueText>
                                    {structureSet.generationModel.label}
                                </ValueText>
                            </LabelValueBox>
                        )}
                        <StyledIdField
                            label="SOP Instance UID"
                            id={structureSet.dicomUid}
                        />
                    </Box>
                }
                placement="right-start"
            >
                <Info size={12} />
            </Tooltip>
        </Box>
    );
}
